import {
    defaultFillsGraphConfiguration,
    FillsChartType,
    FillsGraphConfiguration,
} from './FillsGraphConfiguration';
import { createConfigurationReducer } from 'widgets/store/configuration/reducer';
import cloneDeep from 'lodash/cloneDeep';

export const fillsGraphConfigReducer =
    createConfigurationReducer<FillsGraphConfiguration>(
        defaultFillsGraphConfiguration,
        upgradeConfig
    );

function upgradeConfig(
    config: FillsGraphConfiguration | undefined
): FillsGraphConfiguration {
    if (!config) {
        return cloneDeep(defaultFillsGraphConfiguration);
    }
    const expectedVsActualConfig = config[FillsChartType.ExpectedVsActual];
    if (
        expectedVsActualConfig.autoHideLastBucketThresholdPercent === undefined
    ) {
        config[FillsChartType.ExpectedVsActual] = {
            ...defaultFillsGraphConfiguration[FillsChartType.ExpectedVsActual],
            ...expectedVsActualConfig,
        };
    }

    const pl = config[FillsChartType.PnL];
    if (pl.displayUnrealizedPnL === undefined) {
        pl.displayUnrealizedPnL = true;
        pl.hideUnrealizedPnLLegend = false;
    }

    const orders = config[FillsChartType.OrderFills];
    if (orders.displayPriceCandles === undefined) {
        orders.displayPriceCandles = false;
        orders.hidePriceCandleLegends = false;
    }
    if (orders.avgExecAndVwapDecimals === undefined) {
        orders.avgExecAndVwapDecimals =
            defaultFillsGraphConfiguration['OrderFills'].avgExecAndVwapDecimals;
    }

    return config;
}
